export default __webpack_public_path__ + "static/media/8.b1847015.mp3";